module.exports = __webpack_public_path__ + "media/ko_kr_s3_KyungMi.7092ef88.oga";